module.exports = __webpack_public_path__ + "static/media/DocumentSending.340b08a9.svg";